// extracted by mini-css-extract-plugin
export var imageBlock = "IconContent-module--imageBlock--f5552";
export var isLeft = "IconContent-module--isLeft--142cc";
export var isSmallIcon = "IconContent-module--isSmallIcon--c5e66";
export var root = "IconContent-module--root--18883";
export var textBlock = "IconContent-module--textBlock--58d48";